<template lang="pug">
    section(id="memberpurchases")
        PurchasesList(context="member-purchases")
</template>

<script>
import PurchasesList from '@/components/PurchasesList.vue'
import { useShopPurchaseStore } from '@/stores'
import pinia from '@/pinia'

export default {
    name: 'MemberPurchases',
    components: {
        PurchasesList
    },
    computed: {
        shopPurchaseStore() {
            return useShopPurchaseStore(pinia);
        }
    },
    beforeDestroy() {
        this.shopPurchaseStore.resetPurchasesPaginated()
    }
}
</script>

<style lang="sass">
#memberpurchases
    padding: 0px
</style>
